import {routes, request} from "./"

export function getProductSoldCounts (commit, payload) {
    return request(commit, routes.reports.getProductSoldCounts, payload, 'post')
}

export function getEmailList (commit, payload) {
    return request(commit, routes.reports.getEmailList, payload, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/reports.js
// module id = 39
// module chunks = 0